import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles.css';

// Global error handlers to prevent console errors
window.addEventListener('unhandledrejection', (event) => {
  // Silently handle unhandled promise rejections from browser extensions
  if (event.reason && event.reason.message && 
      event.reason.message.includes('message channel closed')) {
    event.preventDefault();
  }
});

window.addEventListener('error', (event) => {
  // Handle other potential errors silently if they're from extensions
  if (event.message && event.message.includes('Extension')) {
    event.preventDefault();
  }
});

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);

// Register service worker for PWA functionality
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/serviceWorker.js')
      .then((registration) => {
        console.log('Service Worker registered successfully:', registration.scope);
        
        // Best-effort: register periodic background sync for Company Radio
        // (Chromium only, requires installed PWA + permission). Falls through silently.
        try {
          if ('periodicSync' in registration) {
            navigator.permissions?.query({ name: 'periodic-background-sync' }).then((p) => {
              if (p.state === 'granted') {
                registration.periodicSync.register('radio-poll', { minInterval: 5 * 60 * 1000 })
                  .catch(() => {});
              }
            }).catch(() => {});
          }
        } catch (e) { /* silent */ }
        
        // Check for updates periodically (silently)
        setInterval(() => {
          registration.update().catch(() => {/* silent */});
        }, 60000);
        
        // Listen for updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              if (confirm('New version available! Reload to update?')) {
                newWorker.postMessage({ type: 'SKIP_WAITING' });
                window.location.reload();
              }
            }
          });
        });
      })
      .catch((error) => {
        console.log('Service Worker registration failed:', error.message);
      });
  });
}
